import { ORDER_ENGINE2, ORDER_ENGINE3, SERVER_URL } from "@/config";
import {
  ApolloClient,
  InMemoryCache,
  gql,
  split,
  HttpLink,
} from "@apollo/client";
import { WebSocketLink } from "@apollo/client/link/ws";
import { getMainDefinition } from "@apollo/client/utilities";
import { SubscriptionClient } from "subscriptions-transport-ws";
import axios from "axios";
import { store } from "@/redux/store";
import { Danger, Success } from "@/components/core/Errors";
import { setLoggedIn, setUser } from "@/redux/user/slice";

// const SERVER_URL = "https://qnk3c0s0-8080.inc1.devtunnels.ms"
// const WS_SERVER_URL = "ws://qnk3c0s0-8080.inc1.devtunnels.ms"
// const httpLink = new HttpLink({
//   uri: `${SERVER_URL}/graphql`,
// });

// subscription OrderTransaction($pairId: String, $endDate: String, $startDate: String, $value: String) {
//   orderTransaction(pairId: $pairId, endDate: $endDate, startDate: $startDate, value: $value) {
//     t
//   }
// }

// mutation Mutation($startDate: String, $endDate: String, $pairId: String, $value: String) {
//   orderTransaction(startDate: $startDate, endDate: $endDate, pairId: $pairId, value: $value) {
//     t
//   }
// }

// const wsClient = new SubscriptionClient(`${WS_SERVER_URL}/graphql`, {
//   reconnect: true,
//   connectionParams: {
//     // Add any authentication headers if needed
//     // headers: { ... }
//   }
// });

// const wsLink = new WebSocketLink(wsClient);

// const splitLink = split(
//   ({ query }) => {
//     const definition = getMainDefinition(query);
//     return (
//       definition.kind === 'OperationDefinition' &&
//       definition.operation === 'subscription'
//     );
//   },
//   wsLink,
//   httpLink
// );

// const client = new ApolloClient({
//   link: splitLink,
//   cache: new InMemoryCache()
// });

export function subscribeToOHLCV(pairId, callback) {
  try {
    return client
      .subscribe({
        query: gql`
          subscription OrderTransaction($pairId: String) {
            orderTransaction(pairId: $pairId) {
              t
            }
          }
        `,
        variables: { pairId: pairId },
      })
      .subscribe({
        next(data) {
          callback(data.data);
        },
        error(err) {
          console.error("Subscription error:", err);
        },
      });
  } catch (e) {
    console.log("error123", e);
  }
}

// Your Polygon.io API key

// Create Apollo Client instance
// const client = new ApolloClient({
//   uri: 'https://qnk3c0s0-8080.inc1.devtunnels.ms/graphql', // Update with your GraphQL endpoint
//   cache: new InMemoryCache()
// });
export async function makeApiRequest(path, otherRequests) {
  try {
    const url = new URL(
      `${ORDER_ENGINE2}/api/trading-pairs/historical?pair=${path}${otherRequests}`
    );
    // const url = new URL(`https://api.polygon.io/${path}`);
    // url.searchParams.append('apiKey', apiKey)
    const response = await fetch(url.toString());
    return response.json();
  } catch (error) {
    throw new Error(`Polygon.io request error: ${error.status}`);
  }
}
export async function makeApiRequestForPI42(path, otherRequests) {
  try {
    const url = new URL(
      `${ORDER_ENGINE3}/api/trading-pairs/klines?pair=${path}${otherRequests}`
    );

    const response = await fetch(url.toString());
    return response.json();
  } catch (error) {
    throw new Error(`Polygon.io request error: ${error.status}`);
  }
}

// Makes requests to Polygon.io API
// export async function makeApiRequest(path) {
//     try {
//         const response = await client.query({
//             query: gql`
//                 query GetOHLCV {
//                     getOHLCV(pairId: "BTC/USDT") {
//                         timestamp
//                         open
//                         high
//                         low
//                         close
//                         volume
//                     }
//                 }
//             `
//         });
//         return response.data.getOHLCV;
//     } catch (error) {
//         throw new Error(`GraphQL request error: ${error.message}`);
//     }
// }

export function generateSymbol(exchange, fromSymbol, toSymbol) {
  // Polygon uses X:BTCUSD format
  const short = `${fromSymbol}${toSymbol}`;
  return {
    short,
    full: `${exchange}:${short}`,
  };
}

export function parseFullSymbol(fullSymbol) {
  // Parse Polygon format X:BTCUSD
  const match = fullSymbol.match(/^(\w+):(\w+)$/);
  if (!match) {
    return null;
  }

  // Extract the trading pair
  const pair = match[2];
  const fromSymbol = pair.slice(0, -3);
  const toSymbol = pair.slice(-3);

  return {
    exchange: match[1],
    fromSymbol,
    toSymbol,
    pair,
  };
}

export const logoutUser = async (id) => {
  if (!id) {
    return;
  }

  try {
    await axios
      .post(
        `${process.env.NEXT_PUBLIC_SERVER_URL}user/auth/logout`,
        { userId: id }
        // {
        //   headers: {
        //     Authorization: `Bearer ${token}`,
        //   },
        // }
      )
      .then((res) => {
        if (res) {
          // Success("Logout successful");
          localStorage.removeItem("token");
          localStorage.clear();
          store.dispatch(setUser(null));
          store.dispatch(setLoggedIn(false));
          window.location.href = "/login";
        } else {
          Danger(res?.data?.message || "Logout failed");
        }
      })
      .catch((e) => {
        localStorage.removeItem("token");
        localStorage.clear();
        store.dispatch(setUser(null));
        store.dispatch(setLoggedIn(false));
        window.location.href = "/login";
      });

    // console.log("%c Line:180 🍺 res", "color:#2eafb0", res);
    // if (res) {
    //   // Success("Logout successful");
    //   localStorage.removeItem("token");
    //   localStorage.clear();
    //   store.dispatch(setUser(null));
    //   store.dispatch(setLoggedIn(false));
    //   window.location.href = "/login";
    // } else {
    //   Danger(res?.data?.message || "Logout failed");
    // }
  } catch (error) {
    console.error("Logout error:", error);
    Danger(error?.response?.data?.message || "Logout failed");
    return false;
  }
};
